



























































import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import toast from '@/components/toast';
import { ToastType } from '@/components/toast/tost-type.enum';

import PaginationComponent from '../components/Pagination.vue';
import FilterPeople from '../components/people/FilterPeople.vue';
import PeopleList from '../components/people/PeopleList.vue';
import SearchPeople from '../components/people/SearchPeople.vue';
import { peopleStore } from '../store/people';

declare type Person = {
  name: string;
  cpf?: string;
  email: string;
  events: { name: string; alias: string; username?: string }[];
};

@Component({
  components: {
    Loading,
    SearchPeople,
    FilterPeople,
    PaginationComponent,
    PeopleList,
  },
})
export default class EventsPage extends Vue {
  // LOADING PROPERTIES
  isLoading = true;

  isFetching = false;

  // PAGINATION PROPERTIES
  page = 0;

  pageSize = 0;

  totalPages = 0;

  // PAGINATION METHODS
  async changePage(page: number) {
    await this.fetch(page - 1);
  }

  // CONTENT PROPERTIES
  people: Person[] = [];

  totalEvents: { name: string; alias: string }[] = [];

  searchBy?: string;

  filterType?: string;

  filterValue?: string | Array<string | null>;

  // CONTENT METHODS
  async created() {
    this.isLoading = true;
    await this.fetch();
    this.isLoading = false;
  }

  async onSearch(searchBy: string) {
    this.searchBy = searchBy;
    await this.fetch();
  }

  async onFilter(filterType: string, filterValue?: string | Array<string | null>) {
    this.filterType = filterType;
    this.filterValue = filterValue;
    await this.fetch();
  }

  async fetch(page?: number) {
    try {
      this.isFetching = true;
      const query = {
        page,
        searchBy: this.searchBy,
        filterType: this.filterType,
        filterValue: this.filterValue,
      };
      const response = await peopleStore.list(query);
      this.page = response.page;
      this.pageSize = response.pageSize;
      this.totalPages = response.totalPages;
      this.people = [];
      setTimeout(() => {
        this.people = response.content.peoplePerPage;
      }, 200);
      this.totalEvents = response.content.totalEvents;
      this.isFetching = false;
    } catch (err) {
      toast('Erro ao carregar dados', ToastType.ERROR);
    }
  }
}
